<template>
  <div class="container mt-3">
    <h2>Backups</h2>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <p v-if="errorMessage" class="mb-3">{{ errorMessage }}</p>
    </div>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <div class="row">
        <div class="col-md-12 text-right">
          <button
            v-if="userLoggedIn"
            class="btn btn-sm btn-primary"
            @click="showBackupForm()">
            Take a Snapshot
          </button>
        </div>
      </div>

      <div class="row bg-light">
        <div class="col-md-8 text-left text-bold p-2">Name</div>
        <div class="col-md-8 text-left text-bold p-2">Time</div>
        <div class="col-md-4"/>
      </div>
      <div
        v-for="snapshot in snapshots"
        :key="snapshot.id"
        class="row">
        <div class="col-md-8 text-left">{{ snapshot.name }}</div>
        <div class="col-md-8 text-left">{{ snapshot.created }}</div>
        <div class="col-md-4">
          <a
            v-if="userLoggedIn"
            class="btn"
            @click.stop="restoreSnapshot(snapshot)">Restore</a>
          <a
            v-if="userLoggedIn"
            class="btn"
            @click.stop="deleteSnapshot(snapshot)">Delete</a>
        </div>
      </div>
    </div>
    <modal-alert
      v-if="showAlertModal"
      :msg="alertMessage"
      @close="showAlertModal = false"/>
    <modal-confirm
      v-if="showConfirmModal"
      :msg="deleteMessage"
      :action="confirmAction"
      :action-name="confirmActionName"
      @close="showConfirmModal = false"/>
    <modal-save-snapshot
      v-if="showSnapshotModal"
      @close="showSnapshotModal = false"/>
  </div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters, } from 'vuex';
import 'firebase/firestore';
import ModalSaveSnapshot from '../components/ModalSaveSnapshot.vue';
import ModalAlert from '../components/ModalAlert';
import ModalConfirm from '../components/ModalConfirm';
import EventBus from '../services/eventBus.js';
import {
	db,
	groupsCollection,
	labelsCollection,
	languagesCollection,
	translationsCollection,
	setsCollection,
	backupsCollection,
} from '../services/firebaseConfig';

export default {
	name: 'Backups',
	components: {
		ModalSaveSnapshot,
		ModalAlert,
		ModalConfirm,
		EventBus,
	},
	data() {
		return {
			snapshots: [],
			alertMessage: '',
			errorMessage: '',
			deleteMessage: '',
			snapshotToBeConfirmed: null,
			showSnapshotModal: false,
			showAlertModal: false,
			showConfirmModal: false,
			confirmAction: 'confirmBackUpDelete',
			confirmActionName: 'Delete',
			groups: [],
			languages: [],
			labels: [],
			translations: [],
			sets: [],
		};
	},
	computed: {
		...mapGetters(['userLoggedIn',]),
	},
	created() {
		// firebase utils
		backupsCollection
			.orderBy('created', 'desc')
			.get()
			.then((querySnapShot) => {
				querySnapShot.forEach((doc) => {
					let created = doc.data().created;
					const data = {
						id: doc.id,
						name: doc.data().name,
						groups: doc.data().groups,
						languages: doc.data().languages,
						labels: doc.data().labels,
						translations: doc.data().translations,
						sets: doc.data().sets,
						created: created.toDate(),
					};
					this.snapshots.push(data);
				});
			});
	},
	mounted() {
		EventBus.$on('confirmBackUpDelete', () => {
			this.confirmBackUpDelete();
		});
		EventBus.$on('confirmRestore', () => {
			this.confirmRestore();
		});
		EventBus.$on('saveSnapshot', (snapShot) => {
			this.saveSnapshot(snapShot);
		});
		EventBus.$on('closeAlert', () => {
			this.showAlertModal = false;
		});
	},
	beforeDestroy() {
		EventBus.$off('confirmBackUpDelete');
		EventBus.$off('confirmRestore');
		EventBus.$off('saveSnapshot');
		EventBus.$off('closeAlert');
	},
	methods: {
		deleteSnapshot(snapshot) {
			this.deleteMessage =
				"Are you sure want to delete '" + snapshot.name + "'?";
			this.confirmAction = 'confirmBackUpDelete';
			this.confirmActionName = 'Delete';
			this.snapshotToBeConfirmed = snapshot;
			this.showConfirmModal = true;
		},
		confirmBackUpDelete() {
			var _self = this;
			backupsCollection
				.doc(this.snapshotToBeConfirmed.id)
				.delete()
				.then(() => {
					_self.snapshots = _self.snapshots.filter((item) => {
						return item.id !== _self.snapshotToBeConfirmed.id;
					});
				})
				.catch((error) => {
					this.errorMessage = error;
				});
			this.showConfirmModal = false;
		},
		restoreSnapshot(snapshot) {
			this.deleteMessage =
				"Are you sure want to restore '" + snapshot.name + "'?";
			this.confirmAction = 'confirmRestore';
			this.confirmActionName = 'Restore';
			this.snapshotToBeConfirmed = snapshot;
			this.showConfirmModal = true;
		},
		confirmRestore() {
			var _self = this;
			let arrPromises = [];
			let arrDelPromises = [];
			// restore
			this.showConfirmModal = false;
			this.alertMessage = 'Restoration is in progress, please wait...';
			this.showAlertModal = true;
			// Initializing a restoration...
			arrDelPromises.push(
				setsCollection
					.get()
					.then((querySnapShot) => {
						querySnapShot.forEach((doc) => doc.ref.delete());
					})
					.then(() => {
						_self.alertMessage =
							'Restoration is in progress, please wait...' +
							'[Deleted Sets]';
					})
			);
			arrDelPromises.push(
				translationsCollection
					.get()
					.then((querySnapShot) => {
						querySnapShot.forEach((doc) => doc.ref.delete());
					})
					.then(() => {
						_self.alertMessage =
							'Restoration is in progress, please wait...' +
							'[Deleted Translations]';
					})
			);
			arrDelPromises.push(
				labelsCollection
					.get()
					.then((querySnapShot) => {
						querySnapShot.forEach((doc) => doc.ref.delete());
					})
					.then(() => {
						_self.alertMessage =
							'Restoration is in progress, please wait...' +
							'[Deleted Labels]';
					})
			);
			arrDelPromises.push(
				languagesCollection
					.get()
					.then((querySnapShot) => {
						querySnapShot.forEach((doc) => doc.ref.delete());
					})
					.then(() => {
						_self.alertMessage =
							'Restoration is in progress, please wait...' +
							'[Deleted Languages]';
					})
			);
			arrDelPromises.push(
				groupsCollection
					.get()
					.then((querySnapShot) => {
						querySnapShot.forEach((doc) => doc.ref.delete());
					})
					.then(() => {
						_self.alertMessage =
							'Restoration is in progress, please wait...' +
							'[Deleted Groups]';
					})
			);
			Promise.all(arrDelPromises).then(() => {
				_self.alertMessage =
					'Restoration is in progress, please wait...' +
					'Restoring...';
				// Restore Groups [[id, name], [id, name], ...]
				var groupsRestore = JSON.parse(
					this.snapshotToBeConfirmed.groups
				);
				groupsRestore.forEach((eachDoc) => {
					arrPromises.push(
						groupsCollection
							.doc(eachDoc[0])
							.set({
								name: eachDoc[1],
							})
							.then(() => {
								_self.alertMessage =
									'Restoration is in progress, please wait...' +
									'[Restoring Groups]';
							})
					);
				});
				// Restore Languages [[id, language, name], [id, language, name], ...]
				var languagesRestore = JSON.parse(
					this.snapshotToBeConfirmed.languages
				);
				languagesRestore.forEach((eachDoc) => {
					arrPromises.push(
						languagesCollection
							.doc(eachDoc[0])
							.set({
								language: eachDoc[1],
								name: eachDoc[2],
							})
							.then(() => {
								_self.alertMessage =
									'Restoration is in progress, please wait...' +
									'[Restoring Languages]';
							})
					);
				});
				// Restore Labels [[id, name, group.id], [id, name, group.id], ...]
				var labelsRestore = JSON.parse(
					this.snapshotToBeConfirmed.labels
				);
				labelsRestore.forEach((eachDoc) => {
					arrPromises.push(
						labelsCollection
							.doc(eachDoc[0])
							.set({
								name: eachDoc[1],
								group: db.doc('groups/' + eachDoc[2]),
							})
							.then(() => {
								_self.alertMessage =
									'Restoration is in progress, please wait...' +
									'[Restoring Labels]';
							})
					);
				});
				// Restore Translations [[id, name, label.id, language.id], [id, name, label.id, language.id], ...]
				var translationsRestore = this.snapshotToBeConfirmed
					.translations;
				translationsRestore.forEach((eachDoc) => {
					let parsedDoc = JSON.parse(eachDoc);
					arrPromises.push(
						translationsCollection
							.doc(parsedDoc[0])
							.set({
								value: parsedDoc[1],
								label: db.doc('labels/' + parsedDoc[2]),
								language: db.doc('languages/' + parsedDoc[3]),
							})
							.then(() => {
								_self.alertMessage =
									'Restoration is in progress, please wait...' +
									'[Restoring Translations]';
							})
					);
				});
				// Restore Sets [[id, name, labels.idArray, languages.idArray], [id, name, labels.idArray, languages.idArray], ...]
				var setsRestore = JSON.parse(this.snapshotToBeConfirmed.sets);
				setsRestore.forEach((eachDoc) => {
					var labelRefArray = [];
					eachDoc[2].forEach((eachIdLabel) => {
						labelRefArray.push(db.doc('labels/' + eachIdLabel));
					});
					var langRefArray = [];
					eachDoc[3].forEach((eachIdLang) => {
						langRefArray.push(db.doc('languages/' + eachIdLang));
					});
					arrPromises.push(
						setsCollection
							.doc(eachDoc[0])
							.set({
								name: eachDoc[1],
								labels: labelRefArray,
								languages: langRefArray,
							})
							.then(() => {
								_self.alertMessage =
									'Restoration is in progress, please wait...' +
									'[Restoring Sets]';
							})
					);
				});
				Promise.all(arrPromises).then(() => {
					_self.alertMessage = 'Restoration is all done.';
				});
			});
		},
		saveSnapshot(title) {
			let _self = this;
			let arrPromises = [];
			// reset
			_self.groups = [];
			_self.languages = [];
			_self.labels = [];
			_self.translations = [];
			_self.sets = [];
			arrPromises.push(
				groupsCollection.get().then((querySnapShot) => {
					querySnapShot.forEach((doc) => {
						const data = [doc.id, doc.data().name,];
						_self.groups.push(data);
					});
				})
			);
			arrPromises.push(
				languagesCollection.get().then((querySnapShot) => {
					querySnapShot.forEach((doc) => {
						const data = [
							doc.id,
							doc.data().language,
							doc.data().name,
						];
						_self.languages.push(data);
					});
				})
			);
			arrPromises.push(
				labelsCollection.get().then((querySnapShot) => {
					querySnapShot.forEach((doc) => {
						const data = [
							doc.id,
							doc.data().name,
							doc.data().group.id,
						];
						_self.labels.push(data);
					});
				})
			);
			arrPromises.push(
				translationsCollection.get().then((querySnapShot) => {
					querySnapShot.forEach((doc) => {
						const data = JSON.stringify([
							doc.id,
							doc.data().value,
							doc.data().label.id,
							doc.data().language.id,
						]);
						_self.translations.push(data);
					});
				})
			);
			arrPromises.push(
				setsCollection.get().then((querySnapShot) => {
					querySnapShot.forEach((doc) => {
						let labels = [];
						let languages = [];
						let dataLabels = doc.data().labels;
						let dataLanguages = doc.data().languages;
						for (let i in dataLabels) {
							labels.push(dataLabels[i].id);
						}
						for (let i in dataLanguages) {
							languages.push(dataLanguages[i].id);
						}
						const data = [
							doc.id,
							doc.data().name,
							labels,
							languages,
						];
						_self.sets.push(data);
					});
				})
			);

			Promise.all(arrPromises)
				.then(() => {
					let created = firebase.firestore.Timestamp.fromDate(
						new Date()
					);
					backupsCollection
						.add({
							name: title,
							groups: JSON.stringify(_self.groups),
							languages: JSON.stringify(_self.languages),
							labels: JSON.stringify(_self.labels),
							translations: _self.translations,
							sets: JSON.stringify(_self.sets),
							created: created,
						})
						.then((docRef) => {
							const data = {
								id: docRef.id,
								name: title,
								groups: JSON.stringify(_self.groups),
								languages: JSON.stringify(_self.languages),
								labels: JSON.stringify(_self.labels),
								translations: _self.translations,
								sets: JSON.stringify(_self.sets),
								created: created.toDate(),
							};

							this.snapshots.push(data);
							this.showSnapshotModal = false;
							this.alertMessage = 'Snapshot saved successfully';
							this.showAlertModal = true;
						})
						.catch((error) => {
							this.showSnapshotModal = false;
							this.alertMessage = 'Error Occured ' + error;
							this.showAlertModal = true;
						});
				})
				.catch((error) => {
					this.showSnapshotModal = false;
					this.alertMessage = 'Error Occured ' + error;
					this.showAlertModal = true;
				});
		},
		showBackupForm() {
			this.showSnapshotModal = true;
		},
		reset() {
			this.id = '';
			this.name = '';
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/Backups.vue